import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../style/user.css";
import API from "../../api/api";

const Users = () => {

  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [search, setSearch] = useState("");
  const [updatingId, setUpdatingId] = useState(null);

  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {

      const res = await API.get("/admin/users", {
        params: { page, search }
      });

      setUsers(res.data.users);
      setPages(res.data.pages);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, search]);

  // ================= BLOCK / UNBLOCK =================
  const toggleBlock = async (userId, currentStatus) => {
    try {

      setUpdatingId(userId);

      const res = await API.patch(
        `/admin/users/${userId}/block`,
        { isBlocked: !currentStatus }
      );

      // Update UI locally
      setUsers(prev =>
        prev.map(u =>
          u._id === userId ? res.data.user : u
        )
      );

    } catch (err) {
      console.error(err);
      alert("Failed to update user status");
    } finally {
      setUpdatingId(null);
    }
  };

  return (
    <div className="users-container">

      <h2>Users</h2>

      <input
        type="text"
        placeholder="Search by name or email..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="search-box"
      />

      <table className="users-table">

        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Credits</th>
            <th>Purchased</th>
            <th>Used</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {users.map((u) => (
            <tr key={u._id}>

              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>{u.credits}</td>
              <td>{u.totalCreditsPurchased}</td>
              <td>{u.totalCreditsUsed}</td>

              <td>
                {u.isBlocked ? (
                  <span className="blocked">Blocked</span>
                ) : (
                  <span className="active">Active</span>
                )}
              </td>

              <td className="action-buttons">

                <button
                  className="view-btn"
                  onClick={() => navigate(`/admin/users/${u._id}`)}
                >
                  View
                </button>

                <button
                  className="block-btn"
                  disabled={updatingId === u._id}
                  onClick={() => toggleBlock(u._id, u.isBlocked)}
                >
                  {updatingId === u._id
                    ? "Updating..."
                    : u.isBlocked
                    ? "Unblock"
                    : "Block"}
                </button>

              </td>

            </tr>
          ))}
        </tbody>

      </table>

      <div className="pagination">

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Prev
        </button>

        <span>
          Page {page} of {pages}
        </span>

        <button
          disabled={page === pages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>

      </div>

    </div>
  );
};

export default Users;